import React from 'react';
import { Card } from '@totalsoft/rocket-ui';
import Description from '@mui/icons-material/Description';
import { useTranslation } from 'react-i18next';
import ColorPicker from 'components/common/inputs/ColorPicker';
import PropTypes from 'prop-types';
import { Grid, Checkbox, FormControlLabel, FormGroup, FormLabel } from '@mui/material';
import { Autocomplete } from '@totalsoft/rocket-ui';
import { Prompt } from 'react-router-dom';
import { isValid, getErrors } from '@totalsoft/pure-validations-react';

const AllowedStateEditCard = ({ allowedState, documentStateList, onPropertyChanged, validation }) => {
  const { t } = useTranslation();
  return (
    <Card icon={Description} iconColor='primary' title={t('DocumentTypes.DocumentStateTransition.GeneralInfo')}>
      <>
        <Prompt when={allowedState.changed} message={t('DocumentTypes.DocumentStateTransition.LeavingWithoutSavingDocumentAllowedState')} />
        <Grid container spacing={10}>
          <Grid container item xs={5} sm={5} md={5}>
            <Grid item xs={12} sm={12} md={12}>
              <Autocomplete
                fullWidth
                value={allowedState.documentStateId}
                simpleValue
                onChange={value => onPropertyChanged('documentStateId', value, false)}
                options={documentStateList}
                label={t('DocumentTypes.DocumentAllowedState.State')}
                error={!isValid(validation.documentStateId)}
                helperText={getErrors(validation.documentStateId)}
                isSearchable={true}
              />
            </Grid>
            <ColorPicker
              color={allowedState.documentColor}
              onChange={color => onPropertyChanged('documentColor', color)}
              label={t('DocumentTypes.DocumentAllowedState.DocumentStateColor')}
            />
          </Grid>
          <Grid item xs={7} sm={7} md={7}>
            <FormGroup>
              <FormLabel component='legend'>{t('DocumentTypes.DocumentAllowedState.Options')}</FormLabel>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={allowedState.requestComment || false}
                    onChange={event => onPropertyChanged('requestComment', event.target.checked, false)}
                  />
                }
                label={t('DocumentTypes.DocumentAllowedState.RequestComment')}
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={allowedState.commentIsMandatory || false}
                    onChange={event => onPropertyChanged('commentIsMandatory', event.target.checked, false)}
                  />
                }
                label={t('DocumentTypes.DocumentAllowedState.CommentIsMandatory')}
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={allowedState.requestReason || false}
                    onChange={event => onPropertyChanged('requestReason', event.target.checked, false)}
                  />
                }
                label={t('DocumentTypes.DocumentAllowedState.RequestReason')}
              />
            </FormGroup>
          </Grid>
        </Grid>
      </>
    </Card>
  );
};

AllowedStateEditCard.propTypes = {
  onPropertyChanged: PropTypes.func.isRequired,
  allowedState: PropTypes.object.isRequired,
  documentStateList: PropTypes.array.isRequired,
  validation: PropTypes.object.isRequired
};

export default AllowedStateEditCard;
